import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchCustomizedTripsDtlcoverinclall } from "../services/CustomizedTripsDtlcoverinclall";

const CustomizedTripsDtlItinerary = () => {
  const { id } = useParams();
  const [itineraryDays, setItineraryDays] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadItinerary = async () => {
      const res = await fetchCustomizedTripsDtlcoverinclall(decodeURIComponent(id));

      if (res?.status && Array.isArray(res.data)) {
        const formatted = res.data.map((item, index) => ({
          day: index + 1,
          title: item.coveredplace,
          description: item.descriptionplace,
        }));
        setItineraryDays(formatted);
      }
      setLoading(false);
    };

    loadItinerary();
  }, [id]);

  if (loading) return <div>Loading...</div>;
  if (!itineraryDays.length) return <div>No itinerary found</div>;

  return (
    <>
      <section id="itinerary" className="scroll-mt-28">
        <div className="rounded-lg border bg-card text-card-foreground shadow-sm">
          <div className="p-4 md:p-6">
            <h2 className="text-lg md:text-2xl font-bold text-slate-900 mb-4 md:mb-6">
              Day-by-Day Itinerary
            </h2>

            <div className="space-y-4 md:space-y-6">
              {itineraryDays.map((day, index) => (
                <div
                  key={index}
                  className="relative pl-6 md:pl-8 pb-4 md:pb-6 border-l-2 border-primary/20 last:border-l-0 last:pb-0"
                >
                  <div className="absolute -left-[7px] md:-left-[9px] top-0 h-3 w-3 md:h-4 md:w-4 rounded-full bg-primary border-2 border-white shadow-sm" />

                  <span className="inline-block bg-primary/10 text-primary px-2 py-1 rounded-full text-xs font-semibold mb-2">
                    Day {day.day}
                  </span>

                  <h4 className="text-sm md:text-lg font-bold text-slate-800 mb-2">
                    {day.title}
                  </h4>

                  <div
                    className="text-sm md:text-base text-slate-600 leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: day.description }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CustomizedTripsDtlItinerary;
